<div class="d_headerin">
    <!--LOGOS KRISMAR-->
    <img class="d_headerlogo" src="assets/redi/img/logo_full_krismar.webp" />
    <img class="d_headerlogo_icon" src="assets/redi/img/logo_icon_krismar.webp" />

    <!--BTN NAV-->
    <div *ngIf="menuItems.length > 0" class="d_headeroptionsmenu" (click)="openMenu();" [innerHTML]="_icon.bars"></div>

    <div class="d_headerdataconte">
        <!--USER LOGIN-->

        <button *ngIf="!_auth.isAuthenticated()" class="d_buttongrl d_buttoningresar" (click)="openOverlaylogin();">
            <span [innerHTML]="_icon.login"></span>
            <p>Ingresar</p>
        </button>
        <!--USER LOGOUT-->
        <div *ngIf="_auth.isAuthenticated()" class="d_headeruser" id="d_headeruser" (click)="onLogout()">
            <img class="d_headeruserimg" src="assets/redi/img/img_user_default_male.webp">
            <div class="d_headerusertxt">{{_auth.currentUser()?.username}}</div>
            <span class="d_headeruseroptions" id="d_headeruseroptions">
                <!-- <p>Mi perfil</p> -->
                <button class="btn_close">Cerrar sesión</button>
            </span>
        </div>
        <!--LOGOS NOVASCHOOL-->
        <img class="d_headerlogo" src="assets/redi/img/logo_full_novaschool.webp">
        <img class="d_headerlogo_icon" src="assets/redi/img/logo_icon_novaschool.webp">
    </div>
</div>

<!--MENU NAV-->
<div class="d_headernavgrl">
    <!--CLOSE-->
    <div class="d_headerclose" (click)="closeMenu();" [innerHTML]="_icon.times">
    </div>
    <ul class="d_headernav d_navmenu" id="d_headermenu">
        <!-- Menús dinámicos generados desde getMenuConfiguration() -->
        <li *ngFor="let menuItem of menuItems" (click)="menuItem.action(); closeMenu();">
            <div>{{ menuItem.title }}</div>
            <ul *ngIf="menuItem.submenu && menuItem.submenu.length > 0">
                <li *ngFor="let subItem of menuItem.submenu" (click)="loggedIn ? subItem.action() : openOverlaylogin(); closeMenu(); $event.stopPropagation();">
                    <span *ngIf="subItem.icon" [innerHTML]="subItem.icon"></span>
                    {{ subItem.title }}
                </li>
            </ul>
        </li>
    </ul>
</div>